import { getRequestHeaders } from '~/common/helpers.js'
import { createBaseService } from '~/services/base.axios.service.js'

const service = createBaseService(getRequestHeaders)

export default service
